var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mywarningBox",attrs:{"id":"cesiumContainer"}},[_c('div',{staticClass:"myBtnBox33",on:{"click":_vm.goback}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }